import script from "./Process.vue?vue&type=script&lang=ts&setup=true"
export * from "./Process.vue?vue&type=script&lang=ts&setup=true"

import "./Process.vue?vue&type=style&index=0&id=e4665b2c&scoped=true&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4665b2c"]])

export default __exports__